// src/pages/DashboardPage.tsx
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import DashboardLayout from '../components/DashboardLayout';
import ProjectsPage from './ProjectsPage';
import ProjectDetailPage from './ProjectDetailPage';
import SettingsPage from './SettingsPage';
import { useAuth } from '../contexts/AuthContext';

// Placeholder components for future implementation
const DocumentsPage = () => (
  <div>
    <h2>My Documents</h2>
    <p>Your documents will appear here...</p>
  </div>
);

const SupportPage = () => (
  <div>
    <h2>Support</h2>
    <p>Support and help resources will appear here...</p>
  </div>
);

const DashboardPage: React.FC = () => {
  const { currentUser } = useAuth();

  // Redirect to home if not authenticated
  if (!currentUser) {
    return <Navigate to="/" replace />;
  }

  return (
    <DashboardLayout>
      <Routes>
        {/* Default route redirects to projects */}
        <Route index element={<Navigate to="/dashboard/projects" replace />} />
        <Route path="projects" element={<ProjectsPage />} />
        <Route path="projects/:projectId" element={<ProjectDetailPage />} />
        <Route path="documents" element={<DocumentsPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="support" element={<SupportPage />} />
        {/* Catch-all redirect to projects */}
        <Route path="*" element={<Navigate to="/dashboard/projects" replace />} />
      </Routes>
    </DashboardLayout>
  );
};

export default DashboardPage;